import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './AboutPage.css';

const AboutPage = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="about-page">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">ReadTheWord Challenge</h1>
          <h2 className="hero-subtitle">October 2026</h2>
          <p className="hero-question">Can you read the whole Bible in one month?</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="content-section">
        <div className="content-block">
          <p className="opening-paragraph">
            We live in an unprecedented moment in history. Our ancestors treasured the Scriptures, 
            often laboring just to hear or copy a few passages. Today, the Bible sits at our 
            fingertips—in dozens of translations, on every device—yet it too often remains unopened.
          </p>
          
          <p className="truth-statement">
            But here's the surprising truth: reading the entire Bible isn't as overwhelming as it sounds.
          </p>
        </div>

        {/* Statistics Cards */}
        <div className="stats-section">
          <div className="stat-item">
            <div className="stat-number">1,189</div>
            <div className="stat-label">chapters in the Bible</div>
          </div>
          
          <div className="stat-item">
            <div className="stat-number">38</div>
            <div className="stat-label">chapters per day in October</div>
          </div>
          
          <div className="stat-item">
            <div className="stat-number">2-3</div>
            <div className="stat-label">hours daily reading time</div>
          </div>
        </div>

        <div className="content-block">
          <p className="comparison-text">
            For most readers, that's 2–3 hours daily—about the same as a Netflix binge, 
            a football game, or scrolling your feed.
          </p>
        </div>

        {/* Why Join Section */}
        <div className="why-join-section">
          <h2>Why join the challenge?</h2>
          <div className="reasons-list">
            <div className="reason-item">
              <div className="reason-number">1</div>
              <div className="reason-content">
                <h3>Recover the joy of God's Word</h3>
                <p>Trade neglect for nourishment.</p>
              </div>
            </div>
            
            <div className="reason-item">
              <div className="reason-number">2</div>
              <div className="reason-content">
                <h3>See the big picture</h3>
                <p>Reading the Bible quickly helps you grasp the storyline from Genesis to Revelation.</p>
              </div>
            </div>
            
            <div className="reason-item">
              <div className="reason-number">3</div>
              <div className="reason-content">
                <h3>Do it in community</h3>
                <p>You're not alone—others are reading alongside you.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="cta-section">
          <div className="cta-content">
            <p className="cta-text">
              👉 Join us this October at ReadTheWord.app and commit to reading the whole Bible.
            </p>
            <p className="cta-promise">
              You'll be amazed at how God's Word comes alive when you give yourself to it.
            </p>
            
            {!isAuthenticated ? (
              <div className="cta-buttons">
                <Link to="/auth?view=register" className="cta-signup-button">
                  Join the Challenge
                </Link>
                <Link to="/auth" className="cta-login-button">
                  Already have an account?
                </Link>
              </div>
            ) : (
              <div className="cta-buttons">
                <Link to="/" className="cta-dashboard-button">
                  Go to Home
                </Link>
                <Link to="/reading" className="cta-reading-button">
                  Start Reading
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
